import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ThumbCarousel.css';

class ThumbCarousel extends React.Component {
  static propTypes = {
    album: PropTypes.arrayOf(PropTypes.shape()),
    onMouseOver: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
  };
  static defaultProps = {
    album: [],
  };

  handleSlideMouseOver = index => {
    this.props.onMouseOver(index);
  };

  render() {
    const { album, index } = this.props;

    if (!Array.isArray(album) || album.length < 2) {
      return null;
    }

    return (
      <div className={s.thumbCarousel}>
        {album.map((imageObj, i) => (
          <span
            // eslint-disable-next-line react/no-array-index-key
            key={`${imageObj.id}-${i}`}
            className={cx(s.slide, { [s.currentSlide]: index === i })}
            onMouseOver={() => this.handleSlideMouseOver(i)}
          >
            <span className={s.slideButton} />
          </span>
        ))}
      </div>
    );
  }
}

export default withStyles(s)(ThumbCarousel);



// WEBPACK FOOTER //
// ./src/desktop/components/ThumbCarousel/ThumbCarousel.js